import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

const TTL_MS = 60000;

const CACHE_GET = [
    '/api/empresa/get-taller',
    '/api/empresa/list-metodos-pago',
    '/api/capacidad/list-rangos-horario',
    '/api/zona-entrega/list-zonas',
    '/api/zona-entrega/list-sucursales',
    '/api/delivery-servicio/list',
    '/api/delivery-servicio/list-variantes-servicio'
];

interface CacheEntry {
    response: HttpResponse<unknown>;
    at: number;
}

const cache = new Map<string, CacheEntry>();

export const cacheInterceptor: HttpInterceptorFn = (request, next) => {
    const url = request.url;

    if (request.method === 'GET' && CACHE_GET.some((u) => url.includes(u))) {
        const hit = cache.get(url);
        if (hit && Date.now() - hit.at < TTL_MS) {
            return of(hit.response.clone());
        }

        return next(request).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    cache.set(url, { response: event.clone(), at: Date.now() });
                }
            })
        );
    }

    if (request.method !== 'GET') {
        const service = request.url.split('/api/')[1]?.split('/')[0];
        if (service) {
            for (const key of Array.from(cache.keys())) {
                if (key.includes(`/api/${service}`)) {
                    cache.delete(key);
                }
            }
        }
    }

    return next(request);
};
